import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>TEAM BUILDING
                                            </div>
                                            <div className="border_subtitle">Exercise: Identifying team roles
                                            </div>
                                            <p>People in teams have different methods of working and preferred
                                                roles. Research has identified
                                                nine clusters of behaviour typical in team working, known as
                                                Belbin’s team roles.<a className="superscripttext"
                                                                       href="further_info.php?course=300"><sup>7</sup></a> It’s
                                                useful to
                                                identify and understand the interplay of strengths and
                                                ‘allowable weaknesses’:</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/win_puzzle_task.png')}
                                                    alt=""/>
                                            </div>
                                            <p>The following exercise is designed to help you understand your
                                                team’s working styles and their
                                                potential strengths and weaknesses and, therefore, how best to
                                                assign roles or tasks.</p>
                                            <div className="border_subtitle">Follow these steps:</div>
                                            <ol className="brownbullet-list">
                                                <li><p>Give each team member a set of the nine team roles with
                                                    descriptions.</p></li>
                                                <li><p>Ask each team member to describe which team roles best
                                                    describe other members, using
                                                    the card descriptions in the visual above.</p></li>
                                                <li><p> Describe the roles to the team and agree as a group what
                                                    each member’s role preference is
                                                    (remember to listen to each team member, too!)</p></li>
                                                <li><p>Once everyone’s team role has been decided, the team
                                                    discusses who’s most suited to
                                                    undertake each task in the project.</p></li>
                                                <li><p>Assign responsibility for tasks according to people’s
                                                    strengths.</p></li>
                                                <li><p>Record who’s responsible for each task and what their
                                                    deadline is, in line with the overall
                                                    project plan.</p></li>
                                                <li><p>Ask team members to give one single promise and make one
                                                    request connected with the
                                                    project, for example: ‘I promise to keep my mobile on so I
                                                    can be contacted during the day.
                                                    It really frustrates me if tasks are not completed on time
                                                    so, please meet deadlines or
                                                    promise to let me know if you can’t!’
                                                </p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}